module.exports = __webpack_public_path__ + "static/media/mysql.2d73aaba.png";